import type { ComponentProps } from 'react';

import { Cryptocurrency } from '#src/__generated__/globalTypes.ts';
import { EthWalletIcon } from '#src/components/paymentMethods/Icon/EthWalletIcon/index.tsx';
import { SolanaWalletIcon } from '#src/components/paymentMethods/Icon/SolanaWalletIcon/index.tsx';
import { useCryptoBalance } from '#src/hooks/useCryptoBalance.ts';

type Props = Pick<ComponentProps<typeof EthWalletIcon>, 'size'>;

export const CryptoWalletIcon = ({ size }: Props) => {
  const { cryptocurrency } = useCryptoBalance();
  switch (cryptocurrency) {
    case Cryptocurrency.LAMPORT:
      return <SolanaWalletIcon size={size} />;
    case Cryptocurrency.WEI:
    default:
      return <EthWalletIcon size={size} />;
  }
};
